import { createFileRoute } from "@tanstack/react-router";
import { admitCreator } from "@/features/coworlds/records";
import { CreatorLibrary } from "@/features/coworlds";
import { VerifiedViewer } from "@/session/product-session";

export const Route = createFileRoute("/_site/coworlds/")({
  loader: () => admitCreator(),
  component: function CreatorLibraryPage() {
    const creatorViewer = Route.useLoaderData();
    return (
      <VerifiedViewer viewer={creatorViewer}>
        <CreatorLibrary />
      </VerifiedViewer>
    );
  },
});
